var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/loading-screen.tsx";
import React from 'react';
import LandingGradient from 'soapbox/components/landing-gradient';
import { Spinner } from 'soapbox/components/ui';
/** Fullscreen loading indicator. */

const LoadingScreen = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed h-screen w-screen",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LandingGradient, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "fixed d-screen w-screen flex items-center justify-center z-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 40,
    withText: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 11
    }
  }))));
};

export default LoadingScreen;